<template>
	<div id="app" class="captail_wrap" :class="(($route.path == '/complete-steps')? 'noRightSidebar' : '') || (($route.path == '/individual-step1' || $route.path == '/individual-step2' || $route.path == '/individual-step3' || $route.path == '/individual-step3-doc' || $route.path == '/corporate-step1' || $route.path == '/corporate-step2' || $route.path == '/corporate-step3' || $route.path == '/corporate-step4' || $route.path == '/2fa-screen' || $route.path == '/crypto-deposit')? 'p-0' : '')" >{{notificationAlert}}
		<notifications group="notification" :ignoreDuplicates="true" :position="'top right'"/>
		<div class="sessionexpriedouter" v-if="$parent.walletSessionTimeOut">
			<div class="cbox">
				<div class="mb-0">
					<img src="./../../../static/website/images/sessiionOut.svg" alt="session expired" width="170">
				</div>
				<p class="my-3">Your session has expired. Please login again</p>
				<a role="menuitem" class="cap_btn" tabindex="-1" href="#" @click.prevent="logout()">Ok</a>
			</div>
		</div> 
		
		
		<app-left v-if="$route.path != '/individual-step1' && $route.path != '/individual-step2' && $route.path != '/individual-step3' &&  $route.path != '/individual-step3-doc' && $route.path != '/corporate-step1' && $route.path != '/corporate-step2' && $route.path != '/corporate-step3' && $route.path != '/corporate-step4' &&  $route.path != '/2fa-screen' &&  $route.path != '/crypto-deposit'"/>
		<div class="middle_section w-100 mr-0 flex-column" v-if="$route.path != '/individual-step1' && $route.path != '/individual-step2' && $route.path != '/individual-step3' &&  $route.path != '/individual-step3-doc' && $route.path != '/corporate-step1' && $route.path != '/corporate-step2' && $route.path != '/corporate-step3' && $route.path != '/corporate-step4' && $route.path != '/2fa-screen' && $route.path != '/crypto-deposit'">
			<app-header :pageTxt1="pageTxt" />
			<router-view />
		</div>
		<router-view v-if="$route.path == '/individual-step1' || $route.path == '/individual-step2' || $route.path == '/individual-step3' || $route.path == '/individual-step3-doc' || $route.path == '/corporate-step1' || $route.path == '/corporate-step2' || $route.path == '/corporate-step3' || $route.path == '/corporate-step4' || $route.path == '/2fa-screen' || $route.path == '/crypto-deposit'" />
	</div>
</template>

<script>
	import left from './shared/left-nav'
	import right from './shared/right-nav'
	import * as types from '@/types'
	import { mapActions } from 'vuex'
	
	
	import { ProviderCacheMixins } from '@/plugins/vue-provider-cache/mixin'
	
	/*import { Const } from '@/plugins/commonAll/provider/lib/const.cls'*/
	import { Const } from "@/plugins/vue-provider-cache/const.mod";
	import tradingMixins from '@/plugins/trading';
	import { supportMixins } from '@/plugins/support'
	export default {
		name: 'App',
		mixins: [
			ProviderCacheMixins,
			supportMixins,
			tradingMixins
		],
		data() {
			return {
				pageTxt: '',
				oldNotificaion: '',
				apiCalled:[],
				apiCalled1:[],
				ticketUpdate : false
			}
		},
		watch:{
			tradingAccount(value){
				if(!parseInt(this.accountSelected)){
					this.orderlisting(value)
				}
			},
			socialAccount(value){
				if(parseInt(this.accountSelected) == 1){
					this.orderlisting(value)
				}
			},
		},
		components: {
			appLeft: left,
			appRight: right
		},

		computed:{
			notificationAlert(){
				try {
					if(parseInt(this.get_user.profile.gAuthenticatorEnabled) == 0 && parseInt(this.get_user.fresh_user) == 0 ){
						this.$router.replace('/2fa-screen') 
					}else if(parseInt(this.get_user.profile.gAuthenticatorEnabled) == 1 && this.$route.path == '/2fa-screen'  ){
						this.$router.replace('/home') 
					}
					
					//==========================================================================================================
					
						if(this.$route.path != '/individual-step3-doc'){
							if(Object.keys(this.$store.getters['GET_NOTIFICATION_LIST']).length !=0){
								let notification = this.$store.getters['GET_NOTIFICATION_LIST'].notification || []
								if(notification.length > 0){
									this.notificationUnreadList.totalRecords = parseInt(this.notificationUnreadList.totalRecords) + 1
									/*this.$store.commit(Const.SET_UNREAD_NOTIFICATION_DATA, this.notificationUnreadList)*/
									this.$store.commit('/SET_UNREAD_NOTIFICATION_DATA', this.notificationUnreadList)
									for(const item of notification){
											/*this.$notify({
												group: 'notification',
												type: 'warn',
												text: item.message,
												duration: 10000,
												closeOnClick: true
											});*/
										if(item.msgtype == "USER_APPROVE" && !this.apiCalled.includes(item.message)){
											this.apiCalled.push(item.message)
											this._runstateLoad({'globalParams' :{},'localParams' :{ "parameter" : this }})
										}
										if(this.$route.path == '/view' && item.msgtype == "ADMIN_TICKET_THREAD" ){
											this.ticketUpdate = true
											this.$router.replace({ name: "view",query:{id:this.$route.query.id}})
										}
										if(item.msgtype == "DOCUMENT_UPLOAD" && !this.apiCalled1.includes(item.message) ){
											this.apiCalled1.push(item.message)
											this.$router.replace({ name: "view",query:{id:item.payload.ticket_id}}) 
										}
									}
								}
							}
							this.oldNotificaion = this.$store.getters['GET_NOTIFICATION_LIST']
						}
					
				} catch (ex) {
					// console.log('OO-one [ex]', ex)
					return []
				}
			}
		},
		methods:{
			...mapActions({
				_runstateLoad: types.RUN_STATE_LOAD,
				_runLogout: types.RUN_LOGOUT
			}),
			logout(){
				let input_json={
					'globalParams' :{},
					'localParams' :{ "parameter" : this }
				}
				this._runLogout(input_json)
			},
			orderlisting(value){
				if(value.length > 0 && this.$route.name != 'home' && this.$route.name != 'transaction-history'){
					let jsonData = { 
						'globalParams' :{
							'account_id' : value[0].account_id,
							'demo_live' : value[0].demo_live
						},
						'localParams' :{"parameter" : this}
					}
					this._runGetOrderList(jsonData)
				}
	        },
	        subscribPairs(pairList) {
		      	try {
		        	if (pairList.length > 0 && this.$store.getters['/GET_WATCH_LIST_PAIRS'].length == 0) {
		        	  this.$store.getters[Const.GET_PROVIDERS]["priceFeed"].seeders["S_PF_PF"].watchlist(pairList);
		        	}
		      	} catch (e) { }
		    }
		},
		updated() {
			$('.mid_scroll_content').overlayScrollbars({});
		},
		mounted() {
			$(document).ready(function() {
				$("g[aria-labelledby]").hide();
			})
		},
		created(){
			let api_query = {}
			if(localStorage.getItem('transfer_token')){
				api_query = {'transfer' : localStorage.getItem('transfer_token')}
			}
			let is_social = 0;
			if(localStorage.getItem('account-type')){
				is_social = localStorage.getItem('account-type')
				if(parseInt(is_social) == 1){
					this._runTradingAccount({ 'globalParams' :{ 'is_social' : parseInt(is_social) },'localParams' :{"parameter" : this,'page':'home','from': 'change-account'}})
				}
			}
			this._runGetWatchList({ 'globalParams' :{ },'localParams' :{"parameter" : this,'page':'home'}})
			this._runTradingAccount({ 'globalParams' :{ },'localParams' :{"parameter" : this,'page':'home'}})
			this._runstateLoad({'globalParams' :{api_query},'localParams' :{ "parameter" : this }})
			this._runGetNotificationList({ 'globalParams' :{read : "0"}, 'localParams' :{ "parameter" : this } })
			// =========Call from supportMixins==============
			this._runGetTicketReasonList({ 'globalParams' :{},'localParams' :{"parameter" : this}})
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/website/index.vue